<template>
  <div v-if="!loading" class="page-content">
    <div>
      <Modules :modules="modules"/>
    </div>
  </div>
</template>

<script>
  import Modules from '@/views/Modules.vue';
  import Waterwheel from "waterwheel"
  import jsonapiParse from "jsonapi-parse";

  const waterwheel = new Waterwheel(
      {
        base: process.env.VUE_APP_HOST_URL,
        jsonapiPrefix: 'api',
        timeout: 3000,
        accessCheck: false
      }
  );

  export default {
    name: 'Page',
    props:
        {
          slides: Object,
          pageUUID: String,
          pagePath: String,
        },
    data() {
      return {
        loading: true,
        page: [],
        title: '',
        modules: [],
      }
    },
    metaInfo() {
      return {
      title: this.loading ? 'Loading...' : this.title,
      titleTemplate: '%s - Gabiano Holding',
      }
    },
    mounted() {
      this.loadModules();
    },
    methods: {
      loadModules() {
        // Get Page.
        if (this.pageUUID !== '0') {
          waterwheel.jsonapi.get('node/page/' + this.pageUUID, {
            include: 'moduli',
          })
              .then(page => {
                this.page = jsonapiParse.parse(page).data;
                this.title = this.page.title;
                this.modules = this.page.moduli;
          })
              .catch(error => console.log('error on getPage: ', error))
              .finally(() => {
                this.loading = false;
              });
        }

        // News module.
        if (this.pagePath === '/news') {
          this.modules = 'notizie';
        }
        if (this.pagePath === '/contatti') {
          this.modules = 'sedi';
        }

      }
    },
    components: {
      Modules,
    }
  }

</script>
